import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  location: string;
  text: string;
}
const TestimonialCard = ({
  name,
  location,
  text
}: TestimonialProps) => <div className="bg-brand-card p-5 rounded-2xl border-2 border-white/10 flex flex-col h-full hover:border-brand-accent transition-all duration-300 shadow-lg" data-id="element-302">
    <div className="flex items-center mb-4" data-id="element-303">
      <div className="w-12 h-12 bg-brand-accent text-black rounded-xl flex items-center justify-center font-black text-xl mr-4 shrink-0 shadow-[0_2px_0_#CA8A04]" data-id="element-304">
        {name.charAt(0)}
      </div>
      <div data-id="element-305">
        <div className="flex text-brand-accent mb-1" data-id="element-306">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-307" />)}
        </div>
        <p className="font-black text-white text-base leading-tight uppercase" data-id="element-308">
          {name}
        </p>
        <p className="text-xs text-gray-400 font-bold mt-0.5" data-id="element-309">📍 {location}</p>
      </div>
    </div>
    <p className="text-gray-300 text-sm md:text-base italic flex-grow leading-relaxed font-medium" data-id="element-310">
      "{text}"
    </p>
  </div>;
export function TestimonialsSection2() {
  const testimonials = [{
    name: 'Marcelo D.',
    location: 'Rosario | Escuela Técnica N°2 — Electromecánica y Mantenimiento',
    text: 'Por fin tengo checklists y casos de falla pensados para la secundaria técnica. Antes buscaba en manuales europeos y adaptaba durante horas. Ahora entro al taller con la guía lista y los alumnos trabajan sobre máquinas reales desde el primer módulo.'
  }, {
    name: 'Graciela P.',
    location: 'Buenos Aires | Maestra de Taller — Electromecánica Industrial',
    text: 'El tomo de diagnóstico de fallas me cambió las clases. Los chicos entendieron cómo analizar un problema con los casos incluidos. Antes les explicaba en el pizarrón y no quedaba nada. Ahora lo hacen ellos solos con el checklist en la mano.'
  }, {
    name: 'Diego F.',
    location: 'Córdoba | Profesor de Mantenimiento — 5° y 6° año Técnica',
    text: 'Mis alumnos nunca entendían para qué servía el mantenimiento preventivo. Con el Tomo 3 y los casos reales, lo resolvieron ellos mismos en el taller y no lo olvidaron más. Fue un antes y un después en mis clases.'
  }, {
    name: 'Adriana L.',
    location: 'Tucumán | Docente de Seguridad Industrial — Técnica Industrial',
    text: 'Los casos reales del Bono 2 me salvaron el cierre de año. Tenía 3 grupos en distintos niveles y necesitaba propuestas diferentes para cada uno. Ya los tenía todos listos con sus rúbricas. No inventé absolutamente nada.'
  }, {
    name: 'Hernán V.',
    location: 'Mendoza | Profesor de Prácticas Profesionalizantes',
    text: 'El banco de checklists es espectacular. Mis alumnos de 4to año pasaron de no entender qué era una rutina de mantenimiento a diseñar planes preventivos completos en un solo trimestre. Me ahorró horas de planificación y dolores de cabeza.'
  }];
  return <section className="py-8 md:py-16 px-3 bg-brand-dark border-b border-white/10" data-id="element-311">
      <div className="max-w-6xl mx-auto" data-id="element-312">
        <h2 className="text-2xl md:text-4xl font-black text-center mb-8 text-white uppercase text-shadow-lg" data-id="element-313">
          ❤️ LO QUE DICEN LOS DOCENTES QUE YA LO TIENEN
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-314">
          {testimonials.map((t, i) => <div key={i} className={i === 3 ? 'md:col-span-1 lg:col-span-1' : i === 4 ? 'md:col-span-2 lg:col-span-1' : ''} data-id="element-315">
              <TestimonialCard {...t} data-id="element-316" />
            </div>)}
        </div>
      </div>
    </section>;
}